/* assets/byob-deals.js
   Drives the two-column BYOB Deals builder (sections/byob-deals.liquid):
   LEFT product grid + RIGHT sticky summary card (progress, picked list, total,
   Checkout). Tiers carry data-qty + data-unit; clicking one reconfigures the target
   live. On Checkout the chosen variants are added to cart (with BYOB attribution) and
   the shopper is sent to checkout, where a Shopify automatic discount applies the deal. */
(function () {
  const root = document.querySelector('[data-byob-deals]');
  if (!root) return;

  const CUR = root.dataset.cur || '₹';
  const PACK_HANDLE = root.dataset.pack || '';
  const sel = new Map(); // variantId -> qty

  let N = parseInt(root.dataset.qty, 10) || 5;
  let P = parseInt(root.dataset.price, 10) || 99;

  const sum       = root.querySelector('[data-sum]');
  const msgEl     = root.querySelector('[data-msg]');
  const remainEl  = root.querySelector('[data-remain]');
  const targetEl  = root.querySelector('[data-target]');
  const barEl     = root.querySelector('[data-bar]');
  const pickedEl  = root.querySelector('[data-picked]');
  const totalEl   = root.querySelector('[data-total-val]');
  const cta        = root.querySelector('[data-cta]');
  const tiers     = [...root.querySelectorAll('[data-tier]')];

  let lastReadyState = false;

  const reducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const total = () => [...sel.values()].reduce((a, b) => a + b, 0);

  function buzz(pattern) {
    if (reducedMotion()) return;
    if (navigator.vibrate) { try { navigator.vibrate(pattern); } catch (_) {} }
  }
  function confettiBurst() {
    if (reducedMotion()) return;
    const colors = ['#F5333F', '#121212', '#ffbe2e', '#27c39e', '#f6f0e6'];
    const wrap = document.createElement('div');
    wrap.className = 'byob-confetti';
    for (let i = 0; i < 50; i++) {
      const s = document.createElement('span');
      s.style.left = (Math.random() * 100) + 'vw';
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = (Math.random() * 250) + 'ms';
      s.style.animationDuration = (1100 + Math.random() * 700) + 'ms';
      s.style.transform = `translateY(0) rotate(${Math.random() * 90}deg)`;
      wrap.appendChild(s);
    }
    document.body.appendChild(wrap);
    setTimeout(() => wrap.remove(), 2000);
  }

  /* ----- source / attribution ----- */
  function detectSource() {
    try {
      const stored = JSON.parse(sessionStorage.getItem('byob_source') || 'null');
      if (stored && stored.at && (Date.now() - stored.at) < 30 * 60 * 1000) return stored;
    } catch (_) {}
    try {
      const params = new URLSearchParams(location.search);
      const utmSource = params.get('utm_source');
      const ref = params.get('ref');
      if (utmSource || ref) {
        return { source: 'campaign', utm_source: utmSource || '', utm_medium: params.get('utm_medium') || '',
                 utm_campaign: params.get('utm_campaign') || '', ref: ref || '', at: Date.now() };
      }
    } catch (_) {}
    try {
      if (document.referrer) {
        const r = new URL(document.referrer);
        if (r.host !== location.host) {
          if (/instagram|facebook|fb\.|meta|t\.co|twitter|x\.com|threads|whatsapp/i.test(r.host)) return { source: 'social', host: r.host, at: Date.now() };
          if (/google|bing|duckduck|yahoo/i.test(r.host)) return { source: 'search', host: r.host, at: Date.now() };
          return { source: 'external', host: r.host, at: Date.now() };
        }
        if (r.pathname === '/' || r.pathname === '') return { source: 'home', at: Date.now() };
        return { source: 'internal', referrer_path: r.pathname, at: Date.now() };
      }
    } catch (_) {}
    return { source: 'direct', at: Date.now() };
  }
  const SRC = detectSource();

  function fireEvent(name, payload) {
    try { document.dispatchEvent(new CustomEvent('byob:' + name, { detail: payload || {} })); } catch (_) {}
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push(Object.assign({ event: 'byob_' + name }, payload || {}));
    }
  }
  fireEvent('builder_view', { pack_handle: PACK_HANDLE, qty_required: N, bundle_price: P, source: SRC.source });

  function cardFor(id) { return root.querySelector('.bd-prod[data-id="' + id + '"]'); }

  function renderPicked() {
    let html = '';
    sel.forEach((qty, id) => {
      const card = cardFor(id);
      if (!card) return;
      const img = card.dataset.img;
      const title = card.dataset.title || '';
      html += '<li class="bd-pick" data-pick="' + id + '">' +
                '<img class="bd-pick__img" src="' + img + '" alt="" />' +
                '<span class="bd-pick__name">' + title + '</span>' +
                '<span class="bd-pick__qty">×' + qty + '</span>' +
                '<button type="button" class="bd-pick__rm" data-pick-rm="' + id + '" aria-label="Remove">&times;</button>' +
              '</li>';
    });
    pickedEl.innerHTML = html;
  }

  function render() {
    const c = total();
    const remaining = Math.max(0, N - c);

    // product cards
    root.querySelectorAll('.bd-prod').forEach((card) => {
      const id = card.dataset.id;
      const q = sel.get(id) || 0;
      card.classList.toggle('is-sel', q > 0);
      const addBtn = card.querySelector('[data-add]');
      const step = card.querySelector('[data-step]');
      addBtn.hidden = q > 0;
      step.hidden = q === 0;
      if (q > 0) step.querySelector('[data-qn]').textContent = q;
      const incBtn = card.querySelector('[data-inc]');
      if (incBtn) incBtn.disabled = c >= N;
      addBtn.disabled = c >= N;
    });

    // progress + message
    if (barEl) barEl.style.width = Math.min(100, Math.round((c / N) * 100)) + '%';
    if (remainEl) remainEl.textContent = remaining;
    if (targetEl) targetEl.textContent = P;
    if (msgEl) {
      if (remaining > 0) {
        msgEl.innerHTML = "You're <b>" + remaining + " item(s)</b> away from the " + CUR + "<span data-target>" + P + "</span> bundle price";
      } else {
        msgEl.innerHTML = "🎉 Your bundle is ready — " + N + " items for <b>" + CUR + P + "</b>";
      }
    }

    renderPicked();

    // estimated total: flat deal price only once the box is complete
    const est = c >= N ? P : 0;
    if (totalEl) totalEl.textContent = CUR + est;

    // checkout button
    if (c < N) {
      cta.disabled = true;
      cta.textContent = remaining === N ? 'Add to Cart' : ('Add ' + remaining + ' more');
    } else {
      cta.disabled = false;
      cta.textContent = 'Add to Cart · ' + CUR + P;
    }

    const isReady = c >= N;
    if (isReady && !lastReadyState) { buzz([12, 60, 30, 80]); confettiBurst(); }
    lastReadyState = isReady;
  }

  function change(id, delta, card) {
    const c = total();
    if (delta > 0 && c >= N) { buzz(8); return; }
    const next = (sel.get(id) || 0) + delta;
    if (next <= 0) sel.delete(id); else sel.set(id, next);
    if (delta > 0) buzz(10); else buzz(4);
    render();
  }

  function setTier(btn) {
    N = parseInt(btn.dataset.qty, 10) || N;
    P = parseInt(btn.dataset.total, 10) || P;
    root.dataset.qty = N; root.dataset.price = P;
    tiers.forEach((t) => {
      const on = t === btn;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    sel.clear();
    lastReadyState = false;
    render();
    fireEvent('tier_change', { pack_handle: PACK_HANDLE, qty_required: N, bundle_price: P });
  }

  tiers.forEach((btn) => btn.addEventListener('click', () => setTier(btn)));

  // product grid clicks
  root.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-pick-rm]');
    if (rm) { sel.delete(rm.getAttribute('data-pick-rm')); render(); return; }
    const card = e.target.closest('.bd-prod');
    if (!card) return;
    const id = card.dataset.id;
    if (e.target.matches('[data-add],[data-inc]')) change(id, +1, card);
    else if (e.target.matches('[data-dec]')) change(id, -1, card);
  });

  // checkout
  cta.addEventListener('click', async () => {
    if (total() < N) return;   // proceed whenever the box is full (matches the CTA enable: c >= N)
    cta.disabled = true;
    const original = cta.textContent;
    cta.textContent = 'Adding…';
    buzz([8, 40, 8]);

    const at = new Date().toISOString().slice(0, 19).replace('T', ' ');
    const baseProps = {
      _byob_pack: PACK_HANDLE,
      _byob_qty: String(N),
      _byob_bundle_price: String(P),
      _byob_source: SRC.source || 'direct',
      _byob_at: at
    };
    if (SRC.utm_source)   baseProps._byob_utm_source = SRC.utm_source;
    if (SRC.utm_campaign) baseProps._byob_utm_campaign = SRC.utm_campaign;
    if (SRC.ref)          baseProps._byob_ref = SRC.ref;

    const items = [...sel.entries()].map(([id, q]) => ({ id: Number(id), quantity: q, properties: baseProps }));
    fireEvent('bundle_added', { pack_handle: PACK_HANDLE, qty: N, bundle_price: P, source: SRC.source,
      items: items.map(i => ({ variant_id: i.id, quantity: i.quantity })) });

    // Add to cart, then open the cart drawer (instead of jumping to checkout).
    const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    let sectionsParam = '';
    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      sectionsParam = cartElement.getSectionsToRender().map((s) => s.id).join(',');
    }

    try {
      const body = { items: items };
      if (sectionsParam) { body.sections = sectionsParam; body.sections_url = window.location.pathname; }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        const errBody = await res.text().catch(() => '');
        throw new Error('cart-add failed: ' + res.status + ' ' + errBody.slice(0, 200));
      }
      await res.json().catch(function () { return null; });
      try { sessionStorage.removeItem('byob_source'); } catch (_) {}

      // Bundle added → reset the builder, mark "Add Again", then refresh the page
      // so another bundle can be built (the added bundle stays safely in the cart).
      sel.clear();
      cta.textContent = 'Add Again';
      buzz([8, 30, 8]);
      setTimeout(function () { window.location.reload(); }, 700);
      return;
    } catch (err) {
      cta.disabled = false;
      cta.textContent = original;
      fireEvent('bundle_add_error', { pack_handle: PACK_HANDLE, error: String(err) });
      buzz([20, 50, 20]);
    }
  });

  // ?deal=<qty>&price=<P> — lock the builder to one deal (used by the category hub).
  // Sets quantity + price straight from the URL and hides the tier switcher so the
  // page feels dedicated to that single bundle.
  (function applyDealParam() {
    try {
      const params = new URLSearchParams(location.search);
      const deal = parseInt(params.get('deal'), 10);
      if (!deal) return;
      const priceParam = parseInt(params.get('price'), 10);
      N = deal;
      if (priceParam) P = priceParam;
      root.dataset.qty = N;
      root.dataset.price = P;
      sel.clear();
      lastReadyState = false;
      const nav = root.querySelector('[data-tiers]');
      if (nav) nav.style.display = 'none';
    } catch (_) {}
  })();

  render();
})();
